var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "20",
        viewBox: "0 0 16 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M8 2L9.97771 3.91324L12.7023 3.52786L13.1777 6.23817L15.6085 7.52786L14.4 10L15.6085 12.4721L13.1777 13.7618L12.7023 16.4721L9.97771 16.0868L8 18L6.02229 16.0868L3.29772 16.4721L2.82229 13.7618L0.391548 12.4721L1.6 10L0.391548 7.52786L2.82229 6.23817L3.29772 3.52786L6.02229 3.91324L8 2Z",
          fill: "#7AD222",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M11.4598 8.66964C11.4598 8.55804 11.4152 8.44643 11.3348 8.36607L10.7277 7.75893C10.6473 7.67857 10.5357 7.63393 10.4241 7.63393C10.3125 7.63393 10.2009 7.67857 10.1205 7.75893L7.19196 10.692L5.87946 9.375C5.79911 9.29464 5.6875 9.25 5.57589 9.25C5.46429 9.25 5.35268 9.29464 5.27232 9.375L4.66518 9.98214C4.58482 10.0625 4.54018 10.1741 4.54018 10.2857C4.54018 10.3973 4.58482 10.5089 4.66518 10.5893L6.28125 12.2054L6.88839 12.8125C6.96875 12.8929 7.08036 12.9375 7.19196 12.9375C7.30357 12.9375 7.41518 12.8929 7.49554 12.8125L8.10268 12.2054L11.3348 8.97321C11.4152 8.89286 11.4598 8.78125 11.4598 8.66964Z",
          fill: "white",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }